import React from "react";
import { useTranslation } from "react-i18next";

import CustomInput from "../../../shared/custom-components/customInput";
import CustomSelect from "../../../shared/custom-components/select";

const AddUserForm = ({
  readOnly,
  identification,
  firstName,
  lastName,
  phone,
  email,
  status,
  pendingData,
  handlerChange,
  isAddUser,
  isStatusSelect,
  errors = {},
}) => {
  const { t } = useTranslation();

  const showPendingData = isAddUser && pendingData;

  return (
    <div className={`full-column clearfix ${!readOnly ? "editEnable" : ""}`}>
      <div className="row">
        <div className="input col-4">
          <CustomInput
            label={t("clients.users.form.identification")}
            inputClass="add-user-input-padding-fix"
            name={isAddUser ? "identification" : "id"}
            value={identification}
            placeholder={t("general.placeholders.identification")}
            onChange={handlerChange}
            readOnly={readOnly}
          />
          {readOnly && showPendingData && pendingData("identification")}
        </div>

        <div className="input col-4">
          <CustomInput
            label={t("clients.users.form.name")}
            inputClass="add-user-input-padding-fix"
            name="firstName"
            value={firstName}
            placeholder={t("general.placeholders.name")}
            onChange={handlerChange}
            readOnly={readOnly}
            error={!readOnly && errors.firstName}
          />
          {readOnly && showPendingData && pendingData("firstName")}
        </div>
        <div className="input col-4">
          <CustomInput
            label={t("clients.users.form.last_name")}
            inputClass="add-user-input-padding-fix"
            name="lastName"
            value={lastName}
            placeholder={t("general.placeholders.last_name")}
            onChange={handlerChange}
            readOnly={readOnly}
            error={!readOnly && errors.lastName}
          />
          {readOnly && showPendingData && pendingData("lastName")}
        </div>
      </div>

      <div className="row">
        <div className="input col-4">
          <CustomInput
            label={t("clients.users.form.phone")}
            inputClass="add-user-input-padding-fix"
            name="phone"
            value={phone}
            placeholder={t("clients.users.form.phone")}
            onChange={handlerChange}
            readOnly={readOnly}
            error={!readOnly && errors.phone}
          />
          {readOnly && showPendingData && pendingData("phone")}
        </div>

        <div className="input col-4">
          <CustomInput
            label={t("clients.users.form.email")}
            inputClass="add-user-input-padding-fix"
            name="email"
            value={email}
            placeholder={t("clients.users.form.email")}
            onChange={handlerChange}
            readOnly={readOnly}
          />
          {readOnly && showPendingData && pendingData("email")}
        </div>

        <div className="input col-4">
          <label htmlFor="status">{t("clients.users.form.state")}</label>

          {isStatusSelect ? (
            <>
              <div className="form__input--inline">
                <CustomSelect
                  id="userStatus"
                  className={`custom-user input input--text input-w-aux__input input--active`}
                  items={[
                    {
                      name: `${t("clients.users.form.active")}`,
                      value: "ACTIVE",
                    },
                    {
                      name: `${t("clients.users.form.inactive")}`,
                      value: "INACTIVE",
                    },
                    {
                      name: `${t("clients.users.form.deleted")}`,
                      value: "DELETED",
                    },
                  ]}
                  name="status"
                  value={status}
                  valueAttr={"value"}
                  handleChange={handlerChange}
                  readOnly={readOnly}
                />
              </div>
              {pendingData && readOnly && pendingData("status")}
            </>
          ) : (
            <input
              id="status"
              name="status"
              type="text"
              autoComplete="off"
              value={t("general.placeholders.pending_approval")}
              readOnly={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AddUserForm;
